import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    influencerDetails: null,
    campaignDetails: null,
    brandDetails: null,
    loading: false,
}

const influencerDataSlice = createSlice({
    name: "Influencer Details",
    initialState: initialState,
    reducers: {
        setLoading: (state, action) => {
            state.loading = action.payload;
        },
        getInfluencerDetails: (state, actions) => {
            state.influencerDetails = actions.payload,
            state.loading = false;
        },
        getBrandDetails: (state, actions) => {
            state.brandDetails = actions.payload,
            state.loading = false;
        },
        setCampaignDetails: (state, actions) => {
            state.campaignDetails = actions.payload,
            state.loading = false;
        }
    }
})


export const { getInfluencerDetails, setLoading, setCampaignDetails, getBrandDetails } = influencerDataSlice.actions

export default influencerDataSlice.reducer